import { render, staticRenderFns } from "./PWR01G02.vue?vue&type=template&id=7fe05d0a"
import script from "./PWR01G02.vue?vue&type=script&lang=jsx"
export * from "./PWR01G02.vue?vue&type=script&lang=jsx"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fe05d0a')) {
      api.createRecord('7fe05d0a', component.options)
    } else {
      api.reload('7fe05d0a', component.options)
    }
    module.hot.accept("./PWR01G02.vue?vue&type=template&id=7fe05d0a", function () {
      api.rerender('7fe05d0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pwr/PWR01G02.vue"
export default component.exports